module.exports = __webpack_public_path__ + "img/pl3_bg.f503314c.png";